const auth = {
  title: "Auth",
  sign_in: "Sign In to Admin",
  login_error: "Incorrect login. Please try again.",
  login: "Login",
  logout: "Logout",
  email: "Email",
  password: "Password",
  mobile: "Mobile",
  change_password: "Change Password",
  update_password: "Update Password",
  current_password: "Current Password",
  set_password: "Set Password",
  update_password_error: "Failed to update password. Please try again.",
  password_does_not_match_error: "Password does not match.",
  new_password: "New Password",
  new_password_retype: "Retype New Password",
  remember: "Remember me",
  sign_up: "Sign Up",
  no_account: "Don't have an account?",
  success: "Success",
  error: "Error",
  register: "Register",
  register_person: "Register Form (User)",
  register_company: "Register Form (Company)",
  register_success: "Registration success.",
  register_failed: "Registration failed. Check the code and try again.",
  register_company_pending:
    "Registration complete. Access to the company must be approved by an administrator.",
  register_company_pending_existing_user:
    "Your company access request has been sent and must be approved by an administrator. Log in as usual.",
  verification: "Verification",
  verify: "Verify",
  code: "6 Digit Code",
  code_instruction: "A 6 digit code is sent to your email.",
  code_enter: "Enter 6 digit code",
  code_enter_failed: "Incorrect 6 digit code",
  pincode_title: "Enter PIN Code",
  reenter_pincode_title: "Re-enter PIN Code",
  newpincode_title: "Enter New PIN Code",
  currentpincode_title: "Enter Current PIN Code",
  invalid_pincode: "Invalid PIN Code",
  mismatch_pincode: "PIN code does not match",
  success_pincode: "PIN code successfully changed.",
  login_email: "Login via Email",
  login_mobile: "Login via Mobile",
  login_feide: "Login via Feide",
  sms_code: "SMS Code",
  enter_code: "Enter Code",
  enter_code_sms: "Confirmation code is sent to {mobile}",
  sms_otp_send_failed: "SMS not sent. Please contact administrator.",
  sms_otp_incorrect_code: "Incorrect or expired code.",
  error_user_already_an_employee: "User is already an employee of the company.",
  error_user_pending_request:
    "User already has a pending request and still waiting for approval.",
  error_feide_invalid_authorization_url:
    "Failed to get Feide authorization request url. Please contact administrator.",
  error_feide_failed_to_generate_token:
    "Failed to generate authorization token. Please contact administrator",
  feide_want_to_add:
    "User {name} ({email}) does not exist in our system. Do you want your Feide user account be registered in our system?",
  feide_no_add: "You did not accept the requirements. Login aborted.",
  privacy_policy_title: "Privacy Notice",
  privacy_consent_to: "I consent to our",
  privacy_notice: "Privacy Notice",
  privacy_close: "Close",
  forgot: {
    back: "Back",
    send_request: "Send Password Request",
    forgot_t: "Forgot Password",
    confirm_pass: "Confirm Password",
    forgot: "Forgot password?",
    invalidrequest_t: "Invalid Request",
    invalidrequest_m: "The requested link is invalid.",
    reset_t: "Password Reset",
    reset_pass: "Reset Password",
    reset_success_m: "Password reset success!",
    reset_error_m:
      "Cannot reset password at the moment. Please try again in a few minutes.",
    forgot_success_m: "A password reset link has been sent!",
    forgot_error_m: "Cannot send at the moment. Please try again later.",
    unregistered: " is not registered.",
    invalid_token: "Invalid password reset token.",
    invalid_email: "Invalid Email address.",
    valid_token: "A new password is sent to your email address ({email})",
    expired_token: "Password link is expired.",
  },
}
export default auth
